import { render, staticRenderFns } from "./fmRadio.vue?vue&type=template&id=f0bff022&scoped=true"
import script from "./fmRadio.vue?vue&type=script&lang=js"
export * from "./fmRadio.vue?vue&type=script&lang=js"
import style0 from "./fmRadio.vue?vue&type=style&index=0&id=f0bff022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bff022",
  null
  
)

export default component.exports